"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcContextKey = void 0;
/**
 * A unique key for a `RpcContext` value.
 *
 * Provides typesafe access to a value store in a `RpcContext`.
 */
class RpcContextKey {
    symbol = Symbol();
    constructor() { }
    get(context) {
        return context[this.symbol];
    }
    set(context, value) {
        context[this.symbol] = value;
    }
    clear(context) {
        delete context[this.symbol];
    }
}
exports.RpcContextKey = RpcContextKey;
//# sourceMappingURL=RpcRequest.js.map